import {Card, Typography, styled} from '@mui/material';

const StyledTypography = styled(Typography)`
	font-size: 1.25rem;
	font-weight: 600;
	line-height: 1.25;
	letter-spacing: 0.15px;
	color: ${({theme}) => theme.palette.primary.main};
	white-space: pre-line;
	vertical-align: bottom;
`;

const StyledCard = styled(Card)`
	border-radius: 16px;
	padding: 16px;
	background-color: ${({theme}) => theme.brand.secondary.wheat};
`;

export {StyledCard, StyledTypography};
